export default __webpack_public_path__ + "8837a82a4453824ff61b3bd998beaf8c.svg";